import {RecurringInvestmentPage} from 'pages/adminUser/userDetails/tabs/recurringInvestments/UserRecurringInvestment';

export const GeneralRecurringInvestments = () => {
  return <RecurringInvestmentPage />;
};
